import { useEffect, useRef, useState } from "react";
import { fmtINR } from "@/lib/api";

export function PnlHero({ snapshot }) {
  const total = snapshot?.total_pnl ?? 0;
  const realized = snapshot?.realized_pnl ?? 0;
  const unreal = snapshot?.unrealized_pnl ?? 0;
  const positive = total >= 0;
  const color = positive ? "#00E676" : "#FF3B30";

  const [flash, setFlash] = useState("");
  const prev = useRef(total);
  useEffect(() => {
    if (total !== prev.current) {
      setFlash(total > prev.current ? "flash-green" : "flash-red");
      prev.current = total;
      const t = setTimeout(() => setFlash(""), 400);
      return () => clearTimeout(t);
    }
  }, [total]);

  const tradesToday = snapshot?.trades_today ?? 0;
  const maxTrades = snapshot?.max_trades ?? 50;
  const pctFilled = Math.min(100, (tradesToday / maxTrades) * 100);

  return (
    <div className={`px-4 pt-5 pb-4 rounded-sm ${flash}`} data-testid="pnl-hero">
      <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted2">
        Total P&amp;L · {snapshot?.mode || "PAPER"}
      </div>
      <div
        className="mono text-5xl sm:text-6xl font-extrabold tracking-tighter mt-1 leading-none tabular-nums"
        style={{ color }}
        data-testid="total-pnl"
      >
        {positive ? "" : "−"}₹{Math.abs(total).toLocaleString("en-IN", { maximumFractionDigits: 0 })}
      </div>

      <div className="flex gap-4 mt-3">
        <div>
          <div className="text-[10px] uppercase tracking-wider text-muted2">Realized</div>
          <div className="mono text-sm font-bold" style={{ color: realized >= 0 ? "#00E676" : "#FF3B30" }} data-testid="realized-pnl">
            {fmtINR(realized)}
          </div>
        </div>
        <div className="w-px bg-edge" />
        <div>
          <div className="text-[10px] uppercase tracking-wider text-muted2">Open (MTM)</div>
          <div className="mono text-sm font-bold" style={{ color: unreal >= 0 ? "#00E676" : "#FF3B30" }} data-testid="unrealized-pnl">
            {fmtINR(unreal)}
          </div>
        </div>
        <div className="w-px bg-edge" />
        <div>
          <div className="text-[10px] uppercase tracking-wider text-muted2">Win Rate</div>
          <div className="mono text-sm font-bold text-white" data-testid="win-rate">
            {(snapshot?.win_rate ?? 0).toFixed(1)}%
          </div>
        </div>
      </div>

      {/* Trade count progress */}
      <div className="mt-4">
        <div className="flex justify-between text-[10px] uppercase tracking-wider text-muted2 mb-1">
          <span>Trades Today</span>
          <span className="mono text-white" data-testid="trade-count">{tradesToday}/{maxTrades}</span>
        </div>
        <div className="h-1.5 w-full bg-edge rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-[width] duration-500 ease-out"
            style={{ width: `${pctFilled}%`, background: "#007AFF" }}
          />
        </div>
      </div>
    </div>
  );
}
